<template>
  <div class="instruction">
    <img src="@/assets/images/instruction-1.png" />
    <img src="@/assets/images/instruction-2.png" />
  </div>
</template>

<script>
export default {
  name: "Instruction"
};
</script>

<style></style>
